/* @ngInject */
const axletreeLocal = (

) => {
  const self = {}

  return self
}
export default axletreeLocal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/local.service.js